export default "__VITE_ASSET__CZc196pT__"